(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function flash(el) { el.classList.remove("fl"); void el.offsetWidth; el.classList.add("fl"); }

  /* Home: transparent bar au-dessus de la vidéo, blanche au scroll */
  var isHome = document.body.classList.contains("template-index");
  function onScroll() { document.body.classList.toggle("at-top", isHome && window.scrollY < window.innerHeight * 0.6); }
  onScroll(); window.addEventListener("scroll", onScroll, { passive: true });

  /* Menu */
  var menu = $("#menu");
  if (menu) {
    $("#open").addEventListener("click", function () { menu.classList.add("open"); });
    $("#close").addEventListener("click", function () { menu.classList.remove("open"); });
    $$("a", menu).forEach(function (a) { a.addEventListener("click", function () { menu.classList.remove("open"); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") menu.classList.remove("open"); });
  }

  /* Vidéo d'accueil : boucle muette, reprend toujours (retour sur la page, onglet, etc.) */
  function playHero(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function setupHero(v, s, e) {
    v.muted = true; v.loop = true;
    v.addEventListener("loadedmetadata", function () { if (s) v.currentTime = s; playHero(v); });
    v.addEventListener("timeupdate", function () { var end = e || v.duration; if (v.currentTime >= end - 0.12 || v.currentTime < s) v.currentTime = s; });
    v.addEventListener("ended", function () { v.currentTime = s; playHero(v); });
    v.addEventListener("pause", function () { if (!document.hidden) setTimeout(function () { if (v.paused) playHero(v); }, 200); });
    document.addEventListener("visibilitychange", function () { if (!document.hidden) playHero(v); });
    window.addEventListener("pageshow", function () { playHero(v); });
    window.addEventListener("focus", function () { playHero(v); });
    ["touchstart", "click", "scroll", "keydown"].forEach(function (ev) { window.addEventListener(ev, function () { if (v.paused) playHero(v); }, { passive: true }); });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) playHero(v); }).observe(v);
    playHero(v);
  }
  var hv = $("#hero");
  if (hv) setupHero(hv, parseFloat(hv.dataset.start) || 0, parseFloat(hv.dataset.end) || 0);

  /* Fiche produit */
  var root = $("[data-product]");
  if (!root) return;
  var main = $("#main"), thumbs = $$(".thumbs button", root);
  thumbs.forEach(function (b) {
    b.addEventListener("click", function () {
      thumbs.forEach(function (x) { x.classList.toggle("on", x === b); });
      main.classList.toggle("alt", b.dataset.i === "1"); flash(main);
    });
  });
  if (main && !matchMedia("(hover:hover)").matches) {
    main.addEventListener("click", function () { main.classList.toggle("alt"); flash(main); });
  }

  var variants = JSON.parse($("#variants-json").textContent);
  var add = $("#add"), vid = $("#vid"), price = $("#price"), q = $("#q"), qv = $("#qv"), qty = 1;

  var sym = add.dataset.sym || "€";
  function fmt(cents, full) { return (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: (full || cents % 100) ? 2 : 0, maximumFractionDigits: 2 }); }
  function selected() {
    return $$(".sizes", root).map(function (g) { var c = $("input:checked", g); return c ? c.value : null; });
  }
  function refresh() {
    var sel = selected();
    var m = variants.find(function (x) { return sel.every(function (val, i) { return val === null || x["option" + (i + 1)] === val; }); });
    if (m) {
      vid.value = m.id;
      price.textContent = fmt(m.price, true) + " " + sym;
      add.disabled = !m.available;
      add.innerHTML = m.available ? "Add to cart &nbsp;•&nbsp; " + sym + fmt(m.price * qty, false) : "Sold out";
      $$(".sz b", root).forEach(function (b, i) { b.textContent = sel[i] || ""; });
    } else {
      add.disabled = true; add.textContent = "Unavailable";
    }
  }
  $$(".sizes input", root).forEach(function (i) { i.addEventListener("change", refresh); });
  $("#m").addEventListener("click", function () { qty = Math.max(1, qty - 1); q.textContent = qty; qv.value = qty; refresh(); });
  $("#pl").addEventListener("click", function () { qty++; q.textContent = qty; qv.value = qty; refresh(); });
  refresh();
})();
